import { TableEntry, TableOption } from '@tripointe/tripointe-cms/types';

export const INFO_OPTION = {
  action: 'rowInfo',
  src: 'icons/help',
  tooltip: `You don't have permission to edit this item.`
};

const replaceEditWithInfo = (option: TableOption) => {
  return option.action === 'edit' ? INFO_OPTION : option;
};

export const getOptionsPerRowWithEditableCheck = (
  dataSource: TableEntry[],
  options: TableOption[]
) => {
  return (dataSource || []).map((record: TableEntry) => {
    if (record.editable.value === false) {
      return options.map(replaceEditWithInfo);
    }

    return [...options];
  });
};
